"use client";

import { Accordion } from "@mantine/core";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

/**
 * GD-53 — reassurance for a top-up that is taking longer than a healthy one.
 * It shows up 30 seconds after the page loads, and only on the latest ongoing
 * top-up (the first card of the list).
 */
const REASSURANCE_DELAY_MS = 30_000;

const QUESTIONS = [0, 1, 2];

export function OngoingFAQ({ productName }: { productName: string }) {
  const t = useTranslations("dashboard.topup.faq");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), REASSURANCE_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  // "Vodafone PIN England" -> "Vodafone". Without an operator name the copy
  // reads as a dangling sentence, so drop the FAQ entirely.
  const operator = productName.trim().split(/\s+/)[0];

  if (!visible || !operator) return null;

  return (
    <div
      className="mt-3 border-t border-gray-200 pt-3"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-text-muted">
        {t("title")}
      </p>
      <Accordion variant="separated" radius="lg" chevronPosition="right">
        {QUESTIONS.map((index) => (
          <Accordion.Item
            key={index}
            value={`ongoing-faq-${index}`}
            className="border-surface-border bg-surface data-active:border-(--item-border-color)"
          >
            <Accordion.Control className="text-sm font-semibold text-text-primary">
              {t(`items.${index}.question`, { operator })}
            </Accordion.Control>
            <Accordion.Panel className="text-sm text-text-secondary">
              {t(`items.${index}.answer`, { operator })}
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
}
